export const userQueryKeys = {
  agreements: ["memberAgreements"] as const,
  marketingPromptRequired: ["marketingPromptRequired"] as const,
};
